import { ErrorHandler } from '@src/components/ErrorHandler';
import { Modal } from '@uhg-abyss/web/ui/Modal';
import { motion } from 'framer-motion';
import PropTypes from 'prop-types';
import React, { useState } from 'react';

import { TheWidget } from './components/TheWidget';
import { Styles } from './includes/styles';

/**
 * Widget
 *
 * Displays content in a box-like format with a title and optional description. Can be collapsible and have a menu.
 *
 * @param props
 * @returns {Element}
 * @constructor
 */
export function Widget(props) {
  const [isFullscreen, setIsFullscreen] = useState(false);

  return (
    <ErrorHandler location="src/components/Widget/Widget.jsx">
      <motion.div
        animate="open"
        initial={{ opacity: 0 }}
        variants={{
          closed: { opacity: 0 },
          open: { opacity: 1 },
        }}
      >
        <Styles>
          <TheWidget {...{ ...props, ...{ isFullscreen, setIsFullscreen } }} />
          <Modal
            className="full-screen-modal widget-modal"
            isOpen={isFullscreen}
            onClose={() => {
              return setIsFullscreen(false);
            }}
            title=""
          >
            <Modal.Section>
              <TheWidget {...{ ...props, ...{ isFullscreen, setIsFullscreen, withCard: false } }} />
            </Modal.Section>
          </Modal>
        </Styles>
      </motion.div>
    </ErrorHandler>
  );
}

Widget.propTypes = {
  backgroundColor: PropTypes.string,
  button: PropTypes.node,
  children: PropTypes.node,
  collapsed: PropTypes.bool,
  collapsible: PropTypes.bool,
  description: PropTypes.string,
  icon: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  menu: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      onChange: PropTypes.func,
      radios: PropTypes.arrayOf(
        PropTypes.shape({
          label: PropTypes.string,
          value: PropTypes.string,
        })
      ),
      title: PropTypes.string,
      value: PropTypes.string,
    })
  ),
  title: PropTypes.string.isRequired,
  withCard: PropTypes.bool,
};

Widget.defaultProps = {
  backgroundColor: '',
  button: null,
  children: null,
  collapsed: false,
  collapsible: false,
  description: '',
  icon: '',
  menu: [],
  withCard: true,
};
